import './Nav.css';

const ActiviteitenNav = () => {
    return (
        <nav className="custom-nav">
            <a target="_top" href="https://www.zorgnetwerktrento.be/activiteitenkalender-campus-de-vliet">
                Activiteitenkalender Campus De Vliet
            </a>
            <a target="_top" href="https://www.zorgnetwerktrento.be/activiteitenkalender-campus-sint-jozef">
                Activiteitenkalender Campus Sint-Jozef
            </a>
            <a target="_top" href="https://www.zorgnetwerktrento.be/menu-wzc-de-vliet">
                Menu WZC De Vliet
            </a>
            <a target="_top" href="https://www.zorgnetwerktrento.be/menu-wzc-sint-jozef">
                Menu WZC Sint-Jozef
            </a>
            <a target="_top" href="https://www.zorgnetwerktrento.be/cafetaria">
                Cafetaria
            </a>
            <a target="_top" href="https://www.zorgnetwerktrento.be/gebruikersraad">
                Gebruikersraad
            </a>
        </nav>
    );
};
export default ActiviteitenNav;

const NewActNav = () => {
    return (
        <nav className="custom-nav">
            <a target="_top" href="https://www.zorgnetwerktrento.be/cafetaria">
                Cafetaria
            </a>
            <a target="_top" href="https://www.zorgnetwerktrento.be/gebruikersraad">
                Gebruikersraad
            </a>
        </nav>
    );
};

const GeneralActiviteiten = () => {
    return (
        <nav className="custom-nav">
            <a target="_top" href="https://www.zorgnetwerktrento.be/activiteiten-menu-en-verslagen">
                Ga terug naar activiteiten
            </a>
        </nav>
    );
};

export { GeneralActiviteiten, NewActNav };
